import { COUNTRY_CODES } from "../../constants/countries";

export const MENU_VISIBILITY_BY_COUNTRY = {
  [(COUNTRY_CODES as any).ECUADOR]: {
    hide: [],
  },
  [(COUNTRY_CODES as any).PARAGUAY]: {
    hide: ["2.9"], // 2.9 Oculta "Vendedores"
  },
  [(COUNTRY_CODES as any).HONDURAS]: {
    hide: [],
  },
  [(COUNTRY_CODES as any).ELSALVADOR]: {
    hide: ["5.4"],
  },
  // Puerto Rico no esconde nada, y se declara para que conste que se revisó:
  // sin entrada propia caería al respaldo de Ecuador, que es el mismo resultado
  // pero sin dejar dicho que fue una decisión.
  //
  // En particular **Vendedores (2.9) se queda**, al contrario que en Paraguay:
  // medido el 16/10/2026, la empresa de Puerto Rico tiene 52 vendedores en
  // `Salesperson`, así que la pantalla tiene contenido que mostrar.
  [(COUNTRY_CODES as any).PUERTORICO]: {
    hide: [],
  },
};
